module.exports = __webpack_public_path__ + "static/media/picture-(49).8c03f96d.JPG";